import { makeStyles } from "@material-ui/core";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import clsx from "clsx";
import { format } from "date-fns";
import { NotificationType } from "libs/configs/constant";
import { DashboardHeader } from "pages/admin/dashboard/components/general";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: "100%",
    height: "calc(100% - 35px)",
    overflow: "auto",
    "&::-webkit-scrollbar": { width: 5 },
    "&::-webkit-scrollbar-thumb": { background: "#999999" },
  },
  chart: {
    width: "100%",
    height: "100%",
  },
  wrapRow: {
    padding: "5px 10px",
    borderBottom: "1px solid #F3f3f3",
    cursor: "pointer",
  },
  wrapCreateInfo: {
    display: "flex",
    marginTop: 5,
  },
  newCreate: {
    display: "flex",
    alignItems: "center",
    color: "#707070",
    fontSize: "12px",
    marginRight: "10px",
  },
  newCreateBy: { color: "#707070", fontSize: "12px" },
  unRead: {
    backgroundColor: "ghostwhite",
  },
}));

function Notifications(props) {
  const classes = useStyles();
  const _data = props?.data?.map((x) => ({
    ...x,
    dataPasred: JSON.parse(x.data),
  }));

  const history = useHistory();

  return (
    <>
      <div>
        <DashboardHeader
          title="Notifications"
          onSelectViewAll={() => {
            props.onSelectViewAll();
          }}
        />
      </div>

      <div className={classes.wrapChart}>
        {_data?.map((noti, index) => (
          <div
            key={index}
            className={clsx(classes.wrapRow, {
              [classes.unRead]: !noti?.isRead,
            })}
            onClick={() => {
              if (noti.data) {
                const data = JSON.parse(noti.data);
                if (noti.type === NotificationType.RequestDocuments) {
                  // request additional documents
                  history.push(`/admin/smart-visa/document/${data.draftId}`);
                }
              }
              if (noti.type === "Stamped" && noti?.data !== null) {
                const notiData = JSON.parse(noti.data);
                history.push(
                  `/admin/smart-visa/appointment/${notiData?.DraftId}`
                );
              }
              if (noti.type === "ConfirmStamped" && noti?.data !== null) {
                const notiData = JSON.parse(noti.data);
                history.push(
                  `/admin/smart-visa/appointment/${notiData?.DraftId}`
                );
              }
              if (noti.type === "PersonalSentRequest" && noti?.data !== null) {
                const notiData = JSON.parse(noti.data);
                history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
              }
              if (noti.type === "BOISentOtherDep" && noti?.data !== null) {
                const notiData = JSON.parse(noti.data);
                history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
              }

              if (noti.type === "DocumentApproved" && noti?.data !== null) {
                const notiData = JSON.parse(noti.data);
                history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
              }

              if (noti.type === "FinalApproved" && noti?.data !== null) {
                const notiData = JSON.parse(noti.data);
                history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
              }
            }}
          >
            <div style={{ color: "#1a0dab", fontSize: "14px" }}>
              {noti?.title}
            </div>

            <div className={classes.wrapCreateInfo}>
              <div className={classes.newCreate}>
                <span>
                  <NotificationsNoneIcon
                    size="small"
                    style={{ color: "rgb(153, 153, 153)", marginRight: 5 }}
                  />
                </span>
                <div className={classes.newCreate}>
                  {/* {noti?.createDate} */}
                  {format(new Date(noti?.createDate), "yyyy-MM-dd")}
                </div>
                <div className={classes.newCreateBy}>
                  {noti?.dataPasred?.Firstname} {noti?.dataPasred?.LastName}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Notifications;
